import { render, staticRenderFns } from "./EditorUpDownButtons.vue?vue&type=template&id=972d88fa&scoped=true&"
import script from "./EditorUpDownButtons.vue?vue&type=script&lang=js&"
export * from "./EditorUpDownButtons.vue?vue&type=script&lang=js&"
import style0 from "./EditorUpDownButtons.vue?vue&type=style&index=0&id=972d88fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972d88fa",
  null
  
)

export default component.exports